import styled from 'styled-components';

import poweredByGoogleImg from '@images/powered_by_google_on_non_white.png';

export const StyledGoogleLogo = styled.div`
  &::after {
    content: '';
    display: ${({ showLogo }) => (showLogo ? 'block' : 'none')};
    width: 94%;
    height: 35px;
    background-image: url(${poweredByGoogleImg});
    background-size: 125px;
    background-repeat: no-repeat;
    background-position: right;
    border-top: 1px solid #fff;
    transform: translateX(3%);
  }
`;
